import React, { Suspense, useState, useEffect } from "react";
import 'react-responsive-modal/styles.css';
import Drawer from 'react-modern-drawer';  
import { CommonUtilities } from "../../commonUtils";  
import GenerationAllServices from "./generationAllServices";

export default function ValidateContract(param:any) {

    console.log(param)
    const   [ContractList ,setContractList] = useState<any>([]);
    const   [ContractListCount , setContractListCount ] = useState(0);

    useEffect(() => {       
        if(param.openValidateContract === true){             
            ValidateContractListing(); 
        }   

    }, [param.open]);  

    var stsValidateContract = {
        projectId       : 7,
        pageNumber      : 1,
        pageSize        : 10 
    }

    const ValidateContractListing =() =>{ 
        GenerationAllServices.statementQueueValidationListing(stsValidateContract).then((res) => { 
            setContractList(res ); 
            setContractListCount(res && res[0] && res[0].totalRows ? res[0].totalRows : 0); 
            console.log(res[0].totalRows )
        })          
    }

    const closeValidateContract = () => {
        param.closeValidateContract();
    }

    return (
        <>
        <Drawer open={param.openValidateContract} onClose={closeValidateContract} direction={"right"}>

        <div className="ws-9 noBorderRadius noBorder pull-right full-height-vh">
            <div className="box pLarge mtl">
                <div className="ws-12 landing">

                    <div className="ws-4 pm">
                        <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left" style={{minHeight:"80px"}}>
                            <label className="ws-12 text-left mts text-bold" >Project title:</label>
                            <div className="label-entries text-right ws-12 mtl mb">
                                {param?.projectDetails?.projectName}
                            </div>
                        </div>
                    </div>

                    <div className="ws-4 pm">
                        <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left" style={{minHeight:"80px"}}>
                            <label className="ws-12 text-left mts text-bold" >Project Code:</label>
                            <div className="label-entries text-right ws-12 mtl mb">
                                {param?.projectDetails?.projectCode}
                            </div>
                        </div>
                    </div>

                    <div className="ws-4 pm">
                        <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left" style={{minHeight:"80px"}}>
                            <label className="ws-12 text-left mts text-bold" >Project Status</label>
                            <div className="label-entries text-left ws-12 mtl mb mll">

                                <a className="btn-xs m0 mrs" style={{ background: CommonUtilities.lookUpTypeList('projectTag',  (CommonUtilities.lookUpTypeListByKey("ProjectStatus",  param?.projectDetails?.status, "value")), 'bgColor'), 
                                    color: CommonUtilities.lookUpTypeList('projectTag',  (CommonUtilities.lookUpTypeListByKey("ProjectStatus",  param?.projectDetails?.status, "value")), 'fontColor') }}>
                                    {CommonUtilities.lookUpTypeListByKey("ProjectStatus",  param?.projectDetails?.status, "value")}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="ws-12 hide">
                    <div className="ws-10">
                        <button className="icon-btn edit m0 ws-2 pull-right" ng-click="changeDefaultStatementsContracts(searchProFor, 1 ,10);">
                            Search
                        </button>
                        <input type="text" ng-model="searchProFor" ng-keypress="$event.keyCode === 13 ? changeDefaultStatementsContracts(searchProFor, 1 ,10) : null" ng-blur="$event.keyCode === 13 ? changeDefaultStatementsContracts(searchProFor, 1 ,10) : null" className="ws-10 m0 heightReset noBorderRadius "/>
                    </div>
                </div>

                <div className="box-header bg-blue mtl">
                    <h2 className="ws-12">Contract List - {ContractListCount} records found</h2>
                </div>
                <div className="box-content allowHscroll">
                    {ContractListCount === 0 && <div className="alert alert-info mt">No records to display </div>}

                    <div className="table-responsive_big">
                        {ContractListCount > 0 && <table >
                            <thead>
                            <tr>
                                <th> ContractRefNum </th>
                                <th> Contract Title </th>
                                <th> Default Statement Name </th>
                                <th> Accounting Period Name </th>
                                <th> Status Name </th>
                            </tr>
                            </thead>
                            <tbody>
                                {ContractList.map((value:any)=>{
                                        return (                                
                                            <tr >
                                                <td> <a ng-click="contractSummary(contractDefaultStat);"> {value.contractRefNum} </a> </td>
                                                <td> {value.contractTitle} </td>
                                                <td> {value.defaultstatementName} </td>
                                                <td> {value.accountingPeriodName} </td>
                                                <td> {value.statusName} </td>
                                            </tr>
                                        )}
                                    )
                                }

                            </tbody>
                        </table>}                        
                    </div>

                    <div className="box-footer"> 

                    </div>
                </div>

                <div className="box footer pm noBorderRadius">                    
                    <button className="icon-btn delete pull-right" onClick={closeValidateContract}> Close </button>                 

                </div>
            </div>
        </div>

        </Drawer>
        </>

    )

}